module.exports = __webpack_public_path__ + "img/logo.178ba18b.png";